import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="login-wrapper">
        <div className="login-banner">
          <img src="/scala-logo.png" alt="SCALA logo" className="login-banner-logo" />
          <div>
            <div className="login-banner-title">SCALA Membership</div>
            <div className="login-banner-tagline">Celebrating Songwriting</div>
          </div>
        </div>
        <div className="login-gold-divider" />
        <div className="login-card">
          <h2 style={{ textAlign: 'center', marginBottom: '0.75rem' }}>Reset Your Password</h2>

        {submitted ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✉️</div>
            <p style={{ color: '#374151', marginBottom: '1rem' }}>
              If that email address is registered, you'll receive a reset link shortly.
            </p>
            <Link to="/login" style={{ color: 'var(--secondary)', fontWeight: 600 }}>
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            {error && <div className="error-msg">{error}</div>}
            <p style={{ color: '#6b7280', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoFocus
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
              <Link to="/login">Back to sign in</Link>
            </p>
          </>
        )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
